/** Ссылки на режимы игры (по GuardiansNavigator gDaksby). */
export const PLAY_HUB_LINKS = [
  { to: "/play/hub", label: "Все режимы (хаб)", group: "Прочее" },
  { to: "/play/matchmaking", label: "Радар / матчмейкинг", group: "Бой" },
  { to: "/play/online-players", label: "Онлайн / вызовы", group: "Бой" },
  { to: "/play/matchmaking?mode=QR&role=host", label: "QR-бой (хост)", group: "Бой" },
  { to: "/play/arena", label: "Арена", group: "Бой" },
  { to: "/play/deck-builder", label: "Колодный бой", group: "Бой" },
  { to: "/play/base-map", label: "Базы на карте", group: "Карта" },
  { to: "/play/training", label: "Тренировка", group: "Бой" },
  { to: "/play/treasure", label: "Клады", group: "Карта" },
  { to: "/play/wise-tree", label: "Мудрое дерево", group: "Карта" },
  { to: "/play/hotel", label: "Гостиница", group: "Карта" },
  { to: "/play/booster-shop", label: "Бустеры на карте", group: "Карта" },
  { to: "/play/hangar", label: "Ангар", group: "Карта" },
  { to: "/play/location-scan", label: "Скан локации", group: "Карта" },
  { to: "/play/boss-map", label: "Боссы на карте", group: "Карта" },
  { to: "/play/world-boss", label: "Мировой босс", group: "Карта" },
  { to: "/play/card-shop", label: "Магазины карт", group: "Карта" },
  { to: "/play/city-hall", label: "Мэрия", group: "Город" },
  { to: "/play/war", label: "Война городов", group: "Город" },
  { to: "/play/city-chronicle", label: "Летопись", group: "Город" },
  { to: "/play/city-chat", label: "Чат города", group: "Город" },
  { to: "/play/guild", label: "Гильдия", group: "Город" },
  { to: "/play/shop", label: "Игровой магазин", group: "Экономика" },
  { to: "/play/bank", label: "Банк", group: "Экономика" },
  { to: "/play/post-office", label: "Почта", group: "Экономика" },
  { to: "/play/academy", label: "Академия", group: "Прогресс" },
  { to: "/play/daily-quests", label: "Ежедневные задания", group: "Прогресс" },
  { to: "/play/leaderboard", label: "Рейтинг", group: "Прогресс" },
  { to: "/play/shards", label: "Осколки", group: "Колода" },
  { to: "/play/dust-shop", label: "Магазин пыли", group: "Колода" },
  { to: "/play/redeem", label: "QR / redeem", group: "Колода" },
  { to: "/play/airship", label: "Дирижабль", group: "Карта" },
  { to: "/play/virtual-tournament", label: "Виртуальный турнир", group: "Турниры" },
  { to: "/play/daily-tournament", label: "Ежедневный турнир", group: "Турниры" },
  { to: "/play/battle-history", label: "История боёв", group: "Прочее" },
  { to: "/play/pet", label: "Питомец", group: "Прочее" },
  { to: "/play/referral", label: "Рефералы", group: "Прочее" },
  { to: "/play/almanac", label: "Альманах", group: "Прочее" },
  { to: "/play/notifications", label: "Уведомления", group: "Прочее" },
  { to: "/play/rules", label: "Правила", group: "Прочее" },
  { to: "/play/help", label: "Помощь", group: "Прочее" },
] as const
